<template>
    <div class="view-payment-status">
        <viewWrapper>
            <template #content>
                <p24 :endProcess="true" :state="status"/>
                <ADService />
            </template>
        </viewWrapper>
    </div>
</template>

<script>

import { mapActions } from 'vuex';
import viewWrapper from '@/components/layout/viewWrapper/viewWrapper.vue';

import p24 from '@/components/ui/p24/p24.vue';
import ADService from '@/components/functional/ADService/ADService.vue';

export default {
    
    name: 'paymentStatus',
    components: {
        viewWrapper,
        p24,
        ADService,
    },
    data(){
        return {

            status: '',
            paymentData: {},
            done: false,

        };
    },
    methods: {

        ...mapActions('global', [
            'setRemoteAppData',
        ]),

        getPaymentData(){

            if (this.$route.query.url){

                setTimeout(() => {
                    window.location.replace(this.$route.query.url);
                }, 1000);

                return;
            }

            if (!this.$route.query.access_token || !this.$route.query.remote_app || !this.$route.query.order_id) return;

            this.paymentData = {
                selected_facility_token: this.$route.query.access_token,
                order_id: this.$route.query.order_id,
                remote_app: this.$route.query.remote_app,
            };

            const data = {
                accessToken: this.$route.query.access_token,
                remoteApp: this.$route.query.remote_app,
            };

            this.setRemoteAppData(data);
            this.checkStatus();

        },

        checkStatus(){

            this.$http.get('visits/payment_status/', {
                headers: {
                    'Content-Type': 'Application/json',
                },
                params: this.paymentData,
            }).then(response => {

                this.status = response.data.status;

                if (this.status === 'PAID' || this.status === 'COMPLETED' || this.status === 'CANCELED'){

                    this.done = true;
                    return;

                }

                setTimeout(() => { this.checkStatus(); }, 1000 * 30);

            });

        },

    },
    created(){
        this.getPaymentData();
    },

};

</script>

<style lang="scss" src="./paymentStatus.scss" />
